/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_OtherInputs */

const en_pc_dl_other = /** @type {(inputs: Pc_Dl_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other systems and install steps`)
};

const zh_pc_dl_other = /** @type {(inputs: Pc_Dl_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他系统与安装步骤`)
};

/**
* | output |
* | --- |
* | "Other systems and install steps" |
*
* @param {Pc_Dl_OtherInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_other = /** @type {((inputs?: Pc_Dl_OtherInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_OtherInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_other(inputs)
	return zh_pc_dl_other(inputs)
});
export { pc_dl_other as "pc.dl.other" }